import { useCallback, useEffect } from 'react';

const useInfiniteScroll = (loadMore, hasNextPage, isLoading) => {
  const handleScroll = useCallback(() => {
    if (isLoading || !hasNextPage) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    );

    if (scrollTop + windowHeight >= documentHeight - 50) {
      loadMore();
    }
  }, [loadMore, hasNextPage, isLoading]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
};

export default useInfiniteScroll;
